<div class="clearfix">
    <button class="btn pull-right btn-sm btn-secondary" (click)="clickNewReview()"><i class="fa fa-plus"></i> New Review</button>
</div>
<router-outlet></router-outlet>